export const text = [
    {
        summary: 'Push it',
        details: [
            {
                summary: 'Pull it',
                details: [
                    {
                        summary: 'Smear it',
                        details: [
                            {
                                summary: 'Is it gone?',
                                details: [
                                    "Oh no.",
                                    {
                                        summary: 'What can we do?',
                                        details: [
                                            "Accept it."
                                        ],
                                    }
                                ],
                            },
                        ],
                    },
                ],
            },
        ]
    }
];

export default text;